export default "__VITE_ASSET__3c7cd432__"